<script>
	import SignalLines from './signalLines'
	import { getContext } from 'svelte'

	const flight = getContext('flight')
	const lines = flight.getHandler(SignalLines)
</script>
